import { render, staticRenderFns } from "./dependentes.vue?vue&type=template&id=d3787812&scoped=true&"
import script from "./dependentes.vue?vue&type=script&lang=js&"
export * from "./dependentes.vue?vue&type=script&lang=js&"
import style0 from "./dependentes.vue?vue&type=style&index=0&id=d3787812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3787812",
  null
  
)

export default component.exports